import styled from 'styled-components';

import { ONBOARDING_IMGS } from '@_shared/imgs';

export const SliderWrapper = styled.div`
	.slick-dots {
		position: absolute;
		height: 50px;
		top: 35px;

		li {
			margin: 0px;

			button::before {
				opacity: 1;
				color: ${({ theme }) => theme['warmgray-200']};
			}
		}

		li.slick-active button::before {
			color: ${({ theme }) => theme['orange-primary']};
		}
	}
`;

export const TermsSlide = styled.div`
	width: 100%;
	height: calc(100dvh - 82px);
`;

export const TextSlide = styled(TermsSlide)`
	padding-top: 40px;

	display: flex !important;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 14px;

	img {
		width: 220px;
	}
`;

export const FirstSlideContainer = styled.div`
	position: relative;

	display: flex;
	justify-content: center;
	align-items: center;
`;

export const FirstSlideTitle = styled.span`
	color: ${({ theme }) => theme['font-primary']};
	text-align: center;
	font-family: 'Pretendard';
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 32px;

	position: absolute;
	top: 26px;
`;

export const ImgSlide = styled(TermsSlide)`
	display: flex !important;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	gap: 56px;

	img {
		margin-top: 14px;
		margin-bottom: -14px;
	}
`;

export const LottieWrapper = styled.div`
	svg {
		width: 375px;
	}

	background-size: 281px 388px;
	background-repeat: no-repeat;
	background-position: top 14px center;
	background-image: url(${() => ONBOARDING_IMGS.ONBOARDING_IMG2});
`;

export const BottomButtonContainer = styled.div`
	width: 100%;
	max-width: 768px;
	padding: 15px 24px;

	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 12px;

	position: absolute;
	bottom: 0px;
	background-color: white;
`;
